import { useEffect, useState } from 'react';
import { useFirebase } from 'react-redux-firebase';
import { linkedCustomerIds } from '../../lib/customer_links';

/**
 * Empresas de la usuaria actual (Usuarios[] o UsuariosUids). Lo usa la
 * supervisora de empresa para consultar solo sus solicitudes: las reglas
 * rechazan una consulta global (spec 2026-10-05).
 */
export const useMyCustomerIds = (enabled) => {
  const firebase = useFirebase();
  const [state, setState] = useState({ ids: null, error: null });
  useEffect(() => {
    if (!enabled) { setState({ ids: null, error: null }); return undefined; }
    let alive = true;
    const uid = firebase.auth().currentUser?.uid;
    firebase.firestore().collection('customers').get()
      .then((s) => alive && setState({ ids: linkedCustomerIds(s.docs.map((d) => ({ cid: d.id, data: d.data() })), uid), error: null }))
      .catch((e) => alive && setState({ ids: [], error: e }));
    return () => { alive = false; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);
  return state;
};
